import { render } from "./ConfirmDeleteModal.vue?vue&type=template&id=50042b00&scoped=true&ts=true"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=ts"

import "./ConfirmDeleteModal.vue?vue&type=style&index=0&id=50042b00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50042b00"]])

export default __exports__